/* CARLA HOME — Reviews page interactions (animation level "Medio").
   Loaded with defer by ch-reviews-hero (and, redundantly but safely, by
   ch-reviews-stats/topics/faq so each section is self-sufficient).
   Content is visible without JS: hidden states only apply under
   html.ch-rv-js (set inline in the hero).

   Re-entrant: initReveal/initTopics are re-run on shopify:section:load so
   the theme editor keeps working when a section is re-rendered in place. */
(function () {
  'use strict';
  if (window.chReviewsReady) return;
  window.chReviewsReady = true;

  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 749px)');

  /* ---- Reveal with stagger (groups of 3, 120ms steps) ----
     Called once for the whole document on load, and again for just the
     re-rendered section on shopify:section:load. */
  function initReveal(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var targets = scope.querySelectorAll('.ch-rv [data-ch-reveal]:not(.is-in)');
    if (!targets.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var siblings = Array.prototype.filter.call(el.parentElement.children, function (c) {
          return c.hasAttribute('data-ch-reveal');
        });
        var i = Math.max(0, siblings.indexOf(el));
        setTimeout(function () { el.classList.add('is-in'); }, (i % 3) * 120);
        io.unobserve(el);
      });
    }, { threshold: 0.15 });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* ---- Topics: active pill + sticky image swap ----
     One module-level list of controllers + one scroll/resize listener,
     shared across every .ch-rv-topics section and every re-init, so the
     theme editor re-rendering a section never stacks duplicate listeners. */
  var topicsControllers = [];
  var topicsListenerAttached = false;
  var topicsTicking = false;

  function pruneTopicsControllers() {
    topicsControllers = topicsControllers.filter(function (c) {
      return document.contains(c.section);
    });
  }

  function createTopicController(section) {
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-ch-card]'));
    var media = section.querySelector('.ch-rv-topics__media');
    var pills = section.querySelectorAll('[data-ch-pill]');
    if (!cards.length || !media) return null;

    var current = null;

    function readingLine() {
      if (mobile.matches) return media.getBoundingClientRect().bottom + 80;
      return window.innerHeight * 0.55;
    }

    function update() {
      var line = readingLine();
      var active = cards[0];
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].getBoundingClientRect().top < line) active = cards[i];
      }
      if (active === current) return;
      current = active;
      var id = active.getAttribute('data-ch-card');
      var topic = active.getAttribute('data-ch-topic');
      var fig = media.querySelector('[data-ch-media="' + id + '"]');
      if (fig) {
        media.querySelectorAll('figure.is-active').forEach(function (f) { f.classList.remove('is-active'); });
        fig.classList.add('is-active');
      }
      pills.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-ch-pill') === topic);
      });
    }

    return { section: section, update: update };
  }

  function onTopicsScrollOrResize() {
    if (topicsTicking) return;
    topicsTicking = true;
    requestAnimationFrame(function () {
      topicsTicking = false;
      pruneTopicsControllers();
      topicsControllers.forEach(function (c) { c.update(); });
    });
  }

  function initTopics(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var sections = scope.querySelectorAll('.ch-rv-topics');
    if (!sections.length) return;

    pruneTopicsControllers();

    Array.prototype.forEach.call(sections, function (section) {
      /* Drop any stale controller still pointing at this exact section
         (re-init of the same DOM node) before creating a fresh one. */
      topicsControllers = topicsControllers.filter(function (c) { return c.section !== section; });
      var controller = createTopicController(section);
      if (controller) {
        topicsControllers.push(controller);
        controller.update();
      }
    });

    if (!topicsListenerAttached) {
      window.addEventListener('scroll', onTopicsScrollOrResize, { passive: true });
      window.addEventListener('resize', onTopicsScrollOrResize);
      topicsListenerAttached = true;
    }
  }

  /* ---- Init: whole document on load, re-rendered section on editor saves ---- */
  initReveal(document);
  initTopics(document);

  document.addEventListener('shopify:section:load', function (e) {
    /* ch-header.js dispatches this event on document itself (wishlist re-binding,
       several times per page load). Only a real editor re-render targets a
       section element — ignore the rest, or the count-up restarts in a loop. */
    var t = e.target;
    if (!t || t === document || !t.querySelector || !t.querySelector('.ch-rv')) return;
    initReveal(t);
    initTopics(t);
  });

  root.classList.add('ch-rv-ready');
})();
